import { Flex, Text } from '@chakra-ui/react';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonText,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@morressier/alembic';
import ProxyUser from './ProxyUser';
import { AdHocModalOpen } from '../Submission/AuthorsTab/ComposeEmailModal';
import { useKeycloak } from '../AuthHOC';
import { IAuthor } from '@publishing-engine/domain/types/AuthorType';

const ProxyUserMenu = ({
  isProxyUser,
  user,
  handleClick,
  setOpenSendEmailModal,
  authorData
}: {
  isProxyUser: boolean;
  user: {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  handleClick: () => void;
  setOpenSendEmailModal: (data: AdHocModalOpen) => void;
  authorData?: IAuthor |  null;
}) => {
  const { keycloak, currentUser } = useKeycloak();
  const isProxySession = keycloak?.tokenParsed?.IMPERSONATOR_USERNAME;
  const isLoggedInUser = currentUser?.id === user.userId;

  return (
    <Menu ariaLabel="normal menu">
      <MenuButton>
        <ButtonText>
          <Flex gap={2} alignItems="center">
            <FontAwesomeIcon size="lg" icon={faBars} />
          </Flex>
        </ButtonText>
      </MenuButton>

      <MenuList>
        <MenuItem ariaLabel={'View Profile'} onClick={handleClick}>
          <Text textStyle="context">View Profile</Text>
        </MenuItem>
        <MenuItem
          ariaLabel={'Send Email'}
          onClick={() =>
            setOpenSendEmailModal({
              status: true,
              defaultEmail: [user.email]
            })
          }
        >
          <Text textStyle="context">Send Email</Text>
        </MenuItem>

        {isProxyUser && !isLoggedInUser && !isProxySession && (
          <MenuItem ariaLabel={'Proxy as User'} onClick={() => {}}>
            <ProxyUser user={user} authorData={authorData} />
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};

export default ProxyUserMenu;
